import app from './app'
import provider from '../integrations/federateAuth'
let isLoggedIn = null

class Authentication {
	constructor(config) {
		if (!config) {
			throw new Error('Cannot initialize Authentication without a configuration.')
		}
		this.config = config
		if (!provider) {
			throw new Error('Cannot initialize Authentication without a provider.')
		}
	}

	get externalLoginUrl() {
		const env =
			this.config.UrlMappings &&
			this.config.UrlMappings.find(({ HostName }) => {
				return window.location.hostname === HostName
			})

		return (env && env.LoginUrl) || null
	}

	/**
	 * Shows the login dialog, rather than navigating to it. This preserves the user's location and history.
	 */
	showLogin() {
		if (this.externalLoginUrl) {
			window.location.href = this.externalLoginUrl
		} else {
			import('../components/login/LoginDialog').then(({default: LoginDialog}) =>
				new LoginDialog({ size: '30rem' }).show())
		}
	}

	isAuth() {
		return isLoggedIn
	}

	login(username, password, redirect) {
		// prms = provider.login params...
		//	 .then @getSession
		return provider.login(username, password).then(() => {
			isLoggedIn = true

			if (redirect || window.location.href.toLowerCase().indexOf('login') >= 0) {
				// Circumvent route transition since we're doing a hard reload
				const route = app.router.registry.get('Launch')
				app.router.pushState({}, route.title, app.router.href(route))
			}

			window.location.reload(true)

			// Prevent bluebird warning of unreturned promise
			return null
		})
	}

	logout(...params) {
		return provider.logout(...params).then(
			(logoutResponse) => {
			isLoggedIn = false
			this.session = null
			app.logout()
			if (logoutResponse != null && logoutResponse.RedirectURL != null && logoutResponse.RedirectURL.toLowerCase().indexOf('https')>=0) {
				window.location.href = logoutResponse.RedirectURL
			} else {
				this.showLogin()
			}
		})
	}

	// if true is isLoggedIn or null is isLoggedIn
	//	 lgt = provider.logout params...
	//	 lgtThn = lgt.then (ret...) =>
	//		 _onLogout ret...
	getSession(...params) {
		this.session = this.session || provider.getSession(...params)

		this.session
			.then((user) => {
				if(!!window && !!(window as any).heapIdentify) {
					(window as any).heapIdentify(user);
				}
				isLoggedIn = true
			})
			.catch(err => {
				isLoggedIn = false
				this.session = null
				if (location.host.indexOf('evidently') == -1 && location.href.indexOf('covid') == -1)
					this.showLogin()
			})

		return this.session
	}
}
// sssn = provider.getSession params...
// sssnThn = sssn.then (ret...) =>
//	 _onLogin ret...
export default Authentication
